import {
  AbsoluteCenter,
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text,
} from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import { useEffect, useMemo, useState } from "react";
import { isValidMotionProp, motion } from "framer-motion";
import { Helmet } from "react-helmet";

import "./styles.css";
import dayjs from "dayjs";
import { getBetRecord } from "../../api/getApi";
import { Link, useSearchParams } from "react-router-dom";
import { filterNumberColor, formatNumber } from "../../utils/formatNumber";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const BetRecordDetail = ({ fontStyle, setOpenBetRecordDetail } = {}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [loading, setIsLoading] = useState(true);
  const [betRecords, setBetRecords] = useState({});

  const game = searchParams.get("game") || "";

  const numberColor = useMemo(() => {
    const NUMBER = betRecords?.totalWinOrLose || 0;
    if (typeof NUMBER === "string") {
      NUMBER = Number(NUMBER);
    }

    if (NUMBER > 0) {
      return "green.500";
    } else if (NUMBER < 0) {
      return "red.500";
    } else {
      return "white";
    }
  }, [betRecords?.totalWinOrLose]);

  useEffect(() => {
    const fetchBetRecords = async () => {
      setIsLoading(true);
      try {
        // 計算時間範圍：現在到15分鐘前
        const endTime = dayjs();
        const startTime = endTime.subtract(15, "minute");

        const result = await getBetRecord({
          params: {
            str_date: startTime.toDate(),
            end_date: endTime.toDate(),
          },
        });

        if (result && result.data) {
          setBetRecords(result.data);
        }
      } catch (error) {
        console.error("無法獲取投注記錄:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBetRecords();
  }, [game]);

  const getFilteredRecords = useMemo(() => {
    return (
      betRecords[game] || {
        totalBet: 0,
        totalWinOrLose: 0,
      }
    );
  }, [game]);

  return (
    <Flex
      position="fixed"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="rgba(0, 0, 0, 0.6)"
      zIndex="10000"
      justifyContent="center"
      alignItems="center"
    >
      <ChakraBox
        as={Flex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        w="550px"
        minH="600px"
        bgImage={`url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_detail_bg_.png')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        position={"relative"}
        p={6}
        pt={"35px"}
        pl="80px"
        pr="147px"
        pb="85px"
      >
        <Box
          position="absolute"
          bgImage={`url('${COMMON_WEB_PATH}/now888/betRecord/bet_record_close.png')`}
          bgSize="100% 100%"
          bgPos="center"
          w="50px"
          h="50px"
          top="20px"
          right="120px"
          cursor="pointer"
          onClick={() => {
            setOpenBetRecordDetail(false);
          }}
        ></Box>
        <Box
          display="flex"
          flexDirection={"column"}
          alignItems={"center"}
          justifyContent={"center"}
          w="100%"
          h="100%"
          pt="45px"
          pb="20px"
          flex={1}
        >
          <Box h="65px">
            {/* 標題 */}
            <Text
              {...fontStyle}
              bgGradient="linear(to-b, #FFF18E, #F5A623)"
              bgClip="text"
              sx={{
                WebkitTextStroke: "1px #4B1E00",
              }}
            >
              {game}
            </Text>

            {/* 結算標籤 */}
            {/* <Flex justifyContent={"center"}>
              <Image
                src={`${COMMON_WEB_PATH}/now888/betRecord/settle_tag.png`}
              />
            </Flex> */}
          </Box>

          <Box
            flex={1}
            py="10px"
            display={"flex"}
            flexDir={"column"}
            gap="5px"
            alignItems={"center"}
            justifyContent={"center"}
          >
            {/* 投注標籤 */}
            <Box>
              <Image
                src={`${COMMON_WEB_PATH}/now888/betRecord${
                  i18next.language == "tw" ? "" : `/${i18next.language}`
                }/bet_tag.png`}
              />
            </Box>

            <Text
              {...fontStyle}
              bgGradient="linear(to-b, #FFF18E, #F5A623)"
              bgClip="text"
              sx={{
                WebkitTextStroke: "1px #4B1E00",
              }}
            >
              {formatNumber(getFilteredRecords?.totalBet || 0)}
            </Text>

            <Box>
              <Image
                src={`${COMMON_WEB_PATH}/now888/betRecord${
                  i18next.language == "tw" ? "" : `/${i18next.language}`
                }/winloss_tag.png`}
              />
            </Box>

            <Text {...fontStyle} color={numberColor}>
              {formatNumber(getFilteredRecords?.totalWinOrLose || 0)}
            </Text>
          </Box>
        </Box>
      </ChakraBox>{" "}
    </Flex>
  );
};

export default BetRecordDetail;
